import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { Route as LegacyBorrowerRoute } from '~/packages/deliverables/ui/borrower/DeliverableDetailRoute';

// Fragments
const RouteBase = () => {
  return <span>Not implemented</span>;
};

// Exports
export const permissions: PermissionsFn = (context) => {
  if (context.user.userType === 'CAPITAL_PROVIDER') return 'deny';
  return 'allow';
};
export const Route = () => {
  return (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/deliverables" replace />}
    >
      <RouteErrorBoundary
        fallback={({ message, showErrorToast }) => {
          showErrorToast(message);
          return <Navigate to="/deliverables" />;
        }}
      >
        <Flex
          direction="column"
          padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
          gap="1.5rem"
        >
          <PermissionGuard
            permissions={(context) => {
              if (context.flags.enableDeliverablesV5) return 'deny';
              if (context.user.userType !== 'BORROWER') return 'deny';
              return 'allow';
            }}
          >
            <LegacyBorrowerRoute />
          </PermissionGuard>

          <PermissionGuard
            permissions={(context) => {
              if (!context.flags.enableDeliverablesV5) return 'deny';
              return 'allow';
            }}
          >
            <RouteBase />
          </PermissionGuard>
        </Flex>
      </RouteErrorBoundary>
    </PermissionGuard>
  );
};
